import React, { Fragment } from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import { Button } from 'reactstrap';
import { useEffect } from 'react';
import { DatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { useState } from 'react';
import moment from 'moment';

const ChangeDateSettlement = ({ modalAddDate, setModalAddDate, radicado, getSettlemet }) => {
    const [dateSettle, setDateSettle] = useState(null);
    const [observation, setObservation] = useState('');


    useEffect(() => {
        console.log("EstadoModal", modalAddDate)
        console.log("RADICADO", radicado)
        if(radicado!= null && radicado != undefined){
            setDateSettle(radicado.fecha_cierre);
            setObservation(radicado.observacion_cierre);
        }  
    }, [])


    const handleChangeDateSettlement = async (date) => {
        setDateSettle(date);
    }

    const handlerObservation = (value) => {
        setObservation(value);
    }

    const sendChangeDate = async () => {
        //setIsLoading(true);
        let fechaCierre = moment(dateSettle).format('YYYY/MM/DD');

        let dataSend = {
            fecha_cierre: moment(fechaCierre + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
            observacion_cierre: observation,
            id_radicado: radicado.id_radicado
        }

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'radicados/cerrar-radicado', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                console.log("RESPONSE", data)
                setModalAddDate(false);
                getSettlemet();
            })
            .catch((error) => {
                console.log(error)
            })
    };


    return (
        <Fragment>
            <Modal
                open={modalAddDate}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div className="card__title">
                        <h4 className="bold-text">Fecha de Cierre / Radicado</h4>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', }}>

                        <MuiPickersUtilsProvider utils={MomentUtils} >
                            <DatePicker
                                disableFuture
                                openTo="date"
                                disabled={radicado.fecha_cierre != null && radicado.fecha_cierre != undefined ? true : false}
                                label="Fecha de Radicado"
                                views={["year", "month", "date"]}
                                value={dateSettle}
                                onChange={(date) => {
                                    handleChangeDateSettlement(date);
                                }}
                                className='medical-material-form__field'
                                animateYearScrolling
                                format="yyyy/MM/D"
                                InputLabelProps={{
                                    shrink: true,
                                    style: { color: '#646777' }
                                }}
                            />
                        </MuiPickersUtilsProvider>

                        <TextField
                            id=""
                            label="Observación"
                            value={observation}
                            disabled={radicado.observacion_cierre != null && radicado.observacion_cierre != undefined ? true : false}
                            className='medical-material-form__field'
                            onChange={(event) => {
                                handlerObservation(event.target.value);

                            }}
                            style={{ minWidth: '300px', maxWidth: '100%', marginLeft: 10, color: '#646777' }}
                            InputLabelProps={{
                                shrink: true,
                                style: { color: '#646777' }
                            }}
                        //helperText={errors.idThird}
                        >
                        </TextField>

                    </div>



                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {/* {
                            radicado.fecha_cierre != null && radicado.observacion_cierre != '' ?

                        } */}
                        <Button
                            //disabled={disabled}
                            style={{ marginTop: 10, marginRight: 10 }}
                            color="primary"
                            disabled= {radicado.observacion_cierre != null && radicado.observacion_cierre != undefined && radicado.fecha_cierre != null && radicado.fecha_cierre != undefined ? true : false}
                            onClick={() => {
                                sendChangeDate();
                            }}
                        >
                            Guardar
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            color="primary"
                            onClick={() => {
                                setModalAddDate(false);
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>

                </div>

            </Modal>
        </Fragment>
    );
};

export default ChangeDateSettlement;
